import axios from '@/plugins/axios/https';

export function ApiSmsList({ search, limit, offset }) {
  const form = {
    limit,
    offset
  };

  if (search) {
    form.search = search;
  }

  return axios.get('/sms/', form);
}

export function ApiSmsCreate({ subject, type }) {
  const form = {
    subject
  };

  if (type) {
    form.type = type;
  }

  return axios.post('/sms/create/', form);
}

export function ApiSmsDelete({ uuid }) {
  return axios.post(`/sms/${uuid}/delete/`);
}

export function ApiSmsProfile({ uuid }) {
  return axios.get(`/sms/${uuid}/profile/`);
}

export function ApiSmsSave({ uuid, data }) {
  const form = {
    ...data
  };

  return axios.post(`/sms/${uuid}/save/`, form);
}

export function ApiSmsBeefreeToken() {
  return axios.get('/sms/get-beefree-token/');
}

export function ApiSmsSendPreview({ uuid }) {
  return axios.post(`/sms/${uuid}/preview/`);
}

export function ApiSmsApplyTemplate({ uuid, templateUuid }) {
  const form = {
    templateUuid
  };

  return axios.post(`/sms/${uuid}/apply-template/`, form);
}
